import React, { useEffect, useState, useRef } from 'react';
import { useServiceContext } from '../../components/Context/ServiceContext';
import { useBranchContext } from '../../components/Context/BranchContext';
import { useSnackbar } from '.././SnackBar';
import { useTheme } from '@mui/material/styles';
import OutlinedInput from '@mui/material/OutlinedInput';
import Chip from '@mui/material/Chip';
import Checkbox from '@mui/material/Checkbox';
import ListItemText from '@mui/material/ListItemText';
import ConfirmDialog from '../../views/ConfirmDialog';
import { Tabs, Tab, Box, Typography, Button, FormControl, InputLabel, Select, MenuItem, TextField } from '@mui/material';
// import TabContext from '@mui/lab/TabContext';
// import TabList from '@mui/lab/TabList';

import { Dialog, DialogActions, DialogContent, DialogContentText, DialogTitle } from '@mui/material';
//import { Formik, Form, Field, ErrorMessage } from 'formik';

import { useNavigate } from 'react-router-dom';
import { UpdateService } from '../../services/Partner/PartnerApi';

import { useProgressBar } from '../ProgressBar';


const EditServiceDetails = () => {
  const { showProgress } = useProgressBar();
  const userType = localStorage.getItem('userType');
  var styles = { inputDisabled: { border: 'none', background: 'none' } };
  if (userType === 'ADMIN') {
    styles = { inputDisabled: { border: 'none', background: 'none', pointerEvents: 'none' } };
  }
  else if (userType === 'PARTNER') {
    styles = { inputDisabled: { border: 'none', background: 'none', pointerEvents: 'none' } };
  }
  const navigate = useNavigate()
  const isAdmin = userType === 'ADMIN';
  const { showSnackbar } = useSnackbar();
  const { Updateservice, setUpdateService, service, additionalService, FetchServiceCategory, FetchAdditionalService, serviceCategory, EditService, ApproveServiceById, DeleteService, SetServiceFeatured } = useServiceContext();
  /*const { branches,FetchBranches } = useBranchContext();*/

  const AddserviceArray = Updateservice.additionalServices.map(item => item.name);
  const BranchArray = Updateservice.branch.map(item => item.name);

  const statusRef = useRef('');

  // const [items, setItems] = useState([]);



  const ActivateService = async () => {

    const status = statusRef.current.checked;

    const BranchArray = Updateservice.branch.map(item => item.id.toString());
    const AddserviceArray = Updateservice.additionalServices.map(item => item.id.toString());

    try {
      const servicedata = {
        id: Updateservice.id,
        name: Updateservice.name,
        serviceCategoryId: Updateservice.serviceCategoryId,
        price: Updateservice.price,
        description: Updateservice.description,
        imageUrl: Updateservice.imageUrl,
        branchId: BranchArray,
        additionalServiceId: AddserviceArray,
        isActive: status,
        isApproved: Updateservice.isApproved
      };
      showProgress(true);
      const p = await EditService(servicedata);
      showProgress(false);
      showSnackbar('Service updated successfully!'); // Notify success
      // navigate(`/partnerservice`);
      setTimeout(() => {
        navigate(`/editpartnerservice/${p.id}/false`);
      }, 2000); // Adjust delay as needed
    } catch (error) {
      showSnackbar('Error updating Service. Please try again.');
      console.error('Error updating Service:', error);
    }
  };

  const [additionalName, setAdditionalName] = React.useState([]);
  const [branchName, setBranchName] = React.useState([]);
  const theme = useTheme();
  const [selectedbranches, setBranches] = React.useState([]);
  const [selectedAddSer, setAddServ] = useState([]);

  const handleAddServChange = (event) => {
    const {
      target: { value },
    } = event;
    setAdditionalName(
      // On autofill we get a stringified value.
      typeof value === 'string' ? value.split(',') : value,
    );
    const strvalue = value.map(num => num.toString());
    setAddServ(strvalue); // Store selected IDs
  };


  const handelEdit = () => {
    // Navigate to the edit form with the branch ID
    navigate(`/editpartnerservice/${Updateservice.id}/true`, { state: { Updateservice: Updateservice } });
  };
  //const handleDelete = (a) => () => {

  //    
  //    selectedAddSer((a) => a.filter((person) => a !== a));
  //};
  const [chips, setChips] = useState([]);

  const handleDelete = (chipToDelete) => () => {
    setChips((chips) => chips.filter((chip) => chip !== chipToDelete));
  };

  const [openApproval, setOpenApproval] = useState(false);
  const [approved, setApproved] = useState(false);
  const handleCloseApproval = () => {
    setOpenApproval(false); // Close the confirmation dialog 
  };

  const handleConfirmApproval = async () => {
    try {
      const s = await ApproveServiceById(Updateservice.id);
      // branchData.isApproved = true;
      showSnackbar('Service approved successfully');
      //   setUpdateService(s); 

      setApproved(true);
      Updateservice.isApproved = true;
      setOpenApproval(false); // Close the dialog after successful confirmation
      //navigate(`/editpartnerservice/${Updateservice.id}/false`);
      //navigate(`/editpartnerservice/${Updateservice.id}/true`, { state: { Updateservice: Updateservice } });
    } catch (error) {
      console.error('Error approving service:', error);
    }
  };

  const handleApproveClick = () => {

    setOpenApproval(true); // Open the confirmation dialog
  };

  const [open, setOpen] = useState(false);
  const handleActivateService = (event) => {
    const isActive = event.target.checked;
    Updateservice.isActive = isActive;
    setOpen(true); // Open the confirmation dialog
  };

  const handleClose = () => {
    Updateservice.isActive = Updateservice.isActive ? false : true
    setOpen(false); // Close the confirmation dialog
  };

  const handleConfirm = () => {
    ActivateService();
    setOpen(false); // Close the confirmation dialog
  };

  const didFetch = useRef(false);
  const getData = async () => {

    try {
      await FetchServiceCategory();
      await FetchAdditionalService();
      /*  await FetchBranches();*/
      setApproved(Updateservice.isApproved);
    } catch (error) {
      console.error('Error fetching data:', error);
    }
  };
  useEffect(() => {
    if (!didFetch.current) {
      getData();
      didFetch.current = true; // Mark the API call as done
    }
  });

  const [confirmOpen, setConfirmOpen] = useState(false);

  const handleDeleteClick = () => {
    setConfirmOpen(true); // Open the confirmation dialog
  };

  const handleConfirmClose = () => {
    setConfirmOpen(false); // Close the confirmation dialog
  };

  const handleConfirmDelete = async () => {
    setConfirmOpen(false); // Close the confirmation dialog
    if (Updateservice.id) {
      DeleteService(Updateservice.id);
      showSnackbar('service deleted successfully', 'success');
      navigate('/addservice');// Delete the selected brand
    }

  };
  const [isFeatured, setIsFeatured] = useState(false); // State for the "Is Featured" toggle
  const [isConfirmDialogOpen, setIsConfirmDialogOpen] = useState(false); // Confirmation dialog state

  // Handle "Is Featured" toggle
  const handleToggleFeatured = (event) => {
    setIsConfirmDialogOpen(true); // Open confirmation dialog
    const isActive = event.target.checked;
    setIsFeatured(isActive)
  };

  // Confirm toggle action
  const handleConfirmFeatureToggle = async () => {

    setIsConfirmDialogOpen(false); // Close dialog     
    const data = await SetServiceFeatured(Updateservice.id, isFeatured);
  };

  // Cancel toggle action
  const handleCancelFeatureToggle = () => {
    setIsConfirmDialogOpen(false); // Close confirmation dialog
  };

  return (
    <div>
      <main id="main" className="main">
        <div className="pagetitle">
          <h1>Service</h1>
          <nav>
            <ol className="breadcrumb">
              <li className="breadcrumb-item"><a href="/admin">Home</a></li>
              <li className="breadcrumb-item"><a href='/partnerservice'>Services</a></li>
              <li className="breadcrumb-item active"><a href=''>Service Details</a></li>
            </ol>
          </nav>
        </div>
        <section className="section">
          <div className="row">
            <div className="col-lg-12">
              <div className="card">
                <div className="card-body">
                  <h5 className="card-title">New Service Details</h5>
                  <div>
                    <form>
                      <div className="row mb-3">
                        <label htmlFor="inputText" className="col-sm-2 col-form-label">Name</label>

                        <div className="col-sm-10">
                          <input type="text" className="form-control" style={styles.inputDisabled} defaultValue={Updateservice.name}     ></input>
                        </div>
                      </div>
                      <div className="row mb-3">
                        <label htmlFor="inputPassword" className="col-sm-2 col-form-label">Service Category</label>
                        <div className="col-sm-6">
                          <input type="text" className="form-control" style={styles.inputDisabled} defaultValue={Updateservice.serviceCategoryName}     ></input>
                        </div>
                      </div>
                      <div className="row mb-3">
                        <label htmlFor="phone" className="col-sm-2 col-form-label">Price:</label>
                        <div className="col-sm-10">
                          <input type="tel" id="phone" name="phone" className="form-control" required style={styles.inputDisabled} defaultValue={Updateservice.price}     ></input>
                        </div>
                      </div>

                      <div className="row mb-3">
                        <label htmlFor="offlineService" className="col-sm-3 col-form-label">Mark as periodic service </label>
                        <div className="col-sm-9"  >
                          <div className="form-check form-switch">
                            <input
                              className="form-check-input"
                              type="checkbox"
                              id="flexSwitchCheckDefault"
                              style={{ pointerEvents: "none" }}
                              checked={Updateservice.isPeriodic}
                            />
                            <label className="form-check-label" htmlFor="flexSwitchCheckDefault">

                              {Updateservice.isPeriodic ? 'Active' : 'Not Active'}
                            </label>
                          </div>
                        </div>
                      </div>

                      <div className="row mb-3">
                        <label className="col-sm-3 col-form-label">Quick select</label>
                        <div className="col-sm-9">
                          <div className="form-check form-switch">
                            <input
                              className="form-check-input"
                              type="checkbox"
                              style={{ pointerEvents: "none" }}
                              checked={!!Updateservice.isQuickSelect}
                              readOnly
                            />
                            <label className="form-check-label">
                              {Updateservice.isQuickSelect ? 'Enabled' : 'Disabled'}
                            </label>
                          </div>
                        </div>
                      </div>

                      <div className="row mb-3">
                        <label htmlFor="inputEmail" className="col-sm-2 col-form-label">Description</label>
                        <div className="col-sm-10">
                          <input type="email" className="form-control" style={styles.inputDisabled} defaultValue={Updateservice.description}     ></input>
                        </div>
                      </div>
                      {
                        Updateservice.imageUrl !== "" &&
                        <div className="row mb-3">
                          <label htmlFor="inputPassword" className="col-sm-2 col-form-label">Image</label>
                          <div className="col-sm-10">
                            <img height="200px" width="200px" alt="" src={Updateservice.imageUrl}></img>

                          </div>
                        </div>
                      }


                      <div className="row mb-3">
                        <label htmlFor="inputPassword" className="col-sm-2 col-form-label">Branch</label>
                        <div className="col-sm-10">
                          <Box>
                            <Box sx={{ display: 'flex', flexWrap: 'wrap', marginTop: 1 }}>
                              {BranchArray.map((chip) => (
                                <Chip
                                  key={chip}
                                  label={chip}

                                  sx={{ margin: 0.5 }}
                                />
                              ))}
                            </Box>
                          </Box>
                        </div>

                      </div>
                      <div className="row mb-3">
                        <label htmlFor="inputPassword" className="col-sm-2 col-form-label">Additional Services</label>
                        <div className="col-sm-10">
                          <Box>
                            <Box sx={{ display: 'flex', flexWrap: 'wrap', marginTop: 1 }}>
                              {AddserviceArray.map((chip) => (
                                <Chip
                                  key={chip}
                                  label={chip}

                                  sx={{ margin: 0.5 }}
                                />
                              ))}
                            </Box>
                          </Box>
                        </div>
                      </div>
                      <div className="row mb-3">
                        <label htmlFor="phone" className="col-sm-2 col-form-label">Service Charge:</label>
                        <div className="col-sm-10">
                          <input type="tel" id="phone" name="phone" className="form-control" required style={styles.inputDisabled} defaultValue={Updateservice.serviceCharge}     ></input>
                        </div>
                      </div>
                      <div className="row mb-3">
                        <label htmlFor="phone" className="col-sm-2 col-form-label">Discount Percentage:</label>
                        <div className="col-sm-10">
                          <input type="tel" id="phone" name="phone" className="form-control" required style={styles.inputDisabled} defaultValue={Updateservice.discountPercentage}     ></input>
                        </div>
                      </div>
                      {userType !== 'ADMIN' && (
                        <div className="row" style={{ position: 'relative' }}>
                          <div className="col-12 text-center">
                            <Button
                              variant="contained"
                              style={{
                                backgroundColor: '#02176D',
                                color: 'white',
                                position: 'absolute',
                                bottom: '550px', // Adjust distance from the bottom
                                right: '100px',  // Adjust distance from the right
                              }}
                              onClick={handleDeleteClick}
                              className="right-button"
                            >
                              Delete Service
                            </Button>
                          </div>
                        </div>
                      )}

                      {/* Confirmation Dialog */}
                      <Dialog
                        open={confirmOpen}
                        onClose={handleConfirmClose}
                      >
                        <DialogTitle>Confirm Deletion</DialogTitle>
                        <DialogContent>
                          <DialogContentText>
                            Are you sure you want to delete this Service
                          </DialogContentText>
                        </DialogContent>
                        <DialogActions>
                          <Button onClick={handleConfirmClose} color="secondary">
                            Cancel
                          </Button>
                          <Button onClick={handleConfirmDelete} color="primary" autoFocus>
                            Confirm
                          </Button>
                        </DialogActions>
                      </Dialog>
                      {userType !== 'ADMIN' && (
                        <div className="row" style={{ position: 'relative' }}>
                          <div className="col-12 text-center">
                            <Button
                              variant="contained"
                              style={{
                                backgroundColor: '#02176D',
                                color: 'white',
                                position: 'absolute',
                                bottom: '550px', // Adjust distance from the bottom
                                right: '10px',  // Adjust distance from the right
                              }}
                              onClick={handelEdit}
                              className="right-button"
                            >
                              Edit
                            </Button>
                          </div>
                        </div>
                      )}

                      <div className="container">
                        {/* "Is Featured" Toggle Button */}
                        <div
                          style={{
                            position: 'absolute',
                            bottom: '100px', // Adjust distance from the bottom
                            right: '30px',
                            textTransform: 'none'
                          }}
                        >
                          {isAdmin && <div className="form-check form-switch">
                            <input
                              type="checkbox"
                              className="form-check-input"
                              id="toggleFeatured"
                              onChange={handleToggleFeatured}
                              checked={isFeatured}
                            />
                            <label className="form-check-label" htmlFor="toggleFeatured">
                              Mark as Featured
                            </label>
                          </div>
                          }</div>
                      </div>

                      <Dialog open={isConfirmDialogOpen} onClose={handleCancelFeatureToggle}>
                        <DialogTitle>Confirm Action</DialogTitle>
                        <DialogContent>
                          Are you sure you want to {isFeatured ? 'unmark' : 'mark'} this Service as featured?
                        </DialogContent>
                        <DialogActions>
                          <Button onClick={handleCancelFeatureToggle} color="secondary">
                            Cancel
                          </Button>
                          <Button onClick={handleConfirmFeatureToggle} color="primary">
                            Confirm
                          </Button>
                        </DialogActions>
                      </Dialog>
                      <div className="form-check form-switch">
                        {!Updateservice.isApproved && (userType === 'ADMIN') && <div className="row mb-3">
                          <label htmlFor="inputPassword" className="col-sm-2 col-form-label">Approve Service</label>
                          <div className="col-sm-4">
                            <button
                              type="button"
                              className="btn btn-primary"
                              onClick={handleApproveClick}
                            >
                              Approve
                            </button>
                          </div>
                        </div>}
                        {Updateservice.isApproved && (userType === 'ADMIN') && <div className="row mb-3">
                          <label htmlFor="Approval Status" >This Service is Approved</label>
                        </div>}
                        {!Updateservice.isApproved && (userType === 'PARTNER') && <div className="row mb-3">
                          <label htmlFor="Approval Status" >Service not approved by ADMIN  !</label>
                        </div>}
                        {Updateservice.isApproved && (userType === 'PARTNER') && <div><input className="form-check-input" type="checkbox" checked={Updateservice.isActive} id="flexSwitchCheckDefault" defaultValue={Updateservice.status} ref={statusRef} onChange={handleActivateService}></input>
                          <label className="form-check-label" htmlFor="flexSwitchCheckDefault" >Activate/Deactivate Service</label></div>}
                      </div>
                      <ConfirmDialog
                        open={open}
                        onClose={handleClose}
                        onConfirm={handleConfirm}
                        title="Confirm Deactivate/Activate"
                        content="Are you sure you want to Deactivate/Activate this Service?"
                      />
                      <ConfirmDialog
                        open={openApproval}
                        onClose={handleCloseApproval}
                        onConfirm={handleConfirmApproval}
                        title="Confirm Approval"
                        content="Are you sure you want to approve this Service?"
                      />
                    </form>
                  </div>
                </div>
              </div>
            </div>

          </div>
        </section>
      </main>

      <footer id="footer" className="footer">
        <div className="copyright">
          &copy; Copyright <strong><span>CarCrew+</span></strong>. All Rights Reserved
        </div>
      </footer>
    </div>
  )
};

export default EditServiceDetails;